var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.model !== null
    ? _c("div", [
        _vm.isMFAChallenge
          ? _c(
              "div",
              { staticClass: "content-area__content" },
              [
                _c("mfa-challenge-component", {
                  attrs: { mfaChallenge: _vm.model }
                })
              ],
              1
            )
          : _c(
              "div",
              [
                _c("verify-phone-component", {
                  attrs: {
                    submitVerificationCode: _vm.oobaChallenge,
                    resendLink: "authentication/sendverificationcodechallenge"
                  }
                })
              ],
              1
            )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f0cc913", { render: render, staticRenderFns: staticRenderFns })
  }
}